import { motion } from "framer-motion";
import { Globe2, Package, Truck, Leaf } from "lucide-react";

const pillars = [
  { icon: Globe2, title: "Global reach", desc: "USA, Caribbean, Europe, UK, GCC, Asia and Africa." },
  { icon: Package, title: "Wholesale bulk", desc: "Direct-source, container-load pricing." },
  { icon: Truck, title: "Reliable logistics", desc: "On-time delivery, clean documentation." },
  { icon: Leaf, title: "Ethical sourcing", desc: "Eco-friendly packaging & fair-trade partners." },
];

export const About = () => {
  return (
    <section
      id="about"
      className="relative bg-navy py-24 md:py-32 overflow-hidden"
      data-testid="about-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5"
        >
          <p className="kicker mb-6">Who we are</p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl leading-[1.1] tracking-tight text-cream">
            Avado Global Trading is a trusted <span className="text-coral">local distribution and export</span> partner specializing in beverages, confectionery, food, alcohol, beauty &amp; personal care, and general merchandise.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-7"
        >
          <p className="text-base md:text-lg text-white/70 leading-relaxed mb-10">
            We connect leading brands with distributors, retailers, wholesalers, and customers across the U.S., Caribbean, and international markets through strong market presence, reliable supply, and efficient global distribution.
          </p>

          <div className="grid sm:grid-cols-2 gap-6">
            {pillars.map((p, i) => (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 * i }}
                className="flex gap-4 items-start p-5 border border-white/8 rounded-lg bg-white/[0.02] hover:border-coral/40"
                style={{ transitionProperty: "border-color, background-color", transitionDuration: "300ms" }}
                data-testid={`about-pillar-${i}`}
              >
                <span className="shrink-0 w-11 h-11 rounded-full bg-coral/10 text-coral flex items-center justify-center">
                  <p.icon size={20} />
                </span>
                <div>
                  <h4 className="font-display text-lg text-cream mb-1">{p.title}</h4>
                  <p className="text-sm text-white/60">{p.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
